import React from 'react';
import { dictionary } from '../../../dictionary';

const InvoiceModuleStages = ({ stages, possibleStages }) => {
  const activeStagesSet = new Set(stages.map((s) => (s ? s.trim().toUpperCase() : '')));

  return (
    <>
      <div className="field-col">
        <label>{dictionary.esp_dialog_invoice_stages}</label>
        <div className="stage-wrapper">
          {possibleStages.map((stage, index) => {
            const normalizedPossibleStage = stage.trim().toUpperCase();
            const isActive = activeStagesSet.has(normalizedPossibleStage);
            const className = isActive ? 'stage-box' : 'stage-box-disabled';
            return (
              <div key={index} className={className}>
                {stage.trim()}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default InvoiceModuleStages;
